import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

const omnichannelGetConversationExperienceId =
	'service-management.help-center.omnichannel.get-conversation';

export const omnichannelGetConversationExperience = new UFOExperience(
	omnichannelGetConversationExperienceId,
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
